module.exports = "/assets/placeholder.hero.164x119-8529222137d4a399abb824044a0cacb1.png";